import {useMutation} from '@apollo/react-hooks';

import type {ChannelType} from 'nutshell-graphql-types';
import type {
    GetLeadChannels as GetLeadChannelsQuery,
    LeadAddChannel as LeadAddChannelMutation,
    LeadAddChannelVariables as LeadAddChannelMutationVariables,
} from 'nutshell-graphql-types';

import LEAD_ADD_CHANNEL from '../graphql/mutations/lead-add-channel.graphql';
import GET_LEAD_CHANNELS from '../graphql/queries/get-lead-channels.graphql';

export function useAddChannel(): (arg1: {
    channel: ChannelType | 'NO_CHANNEL';
    leadId: string;
}) => Promise<any> {
    const [addChannel] = useMutation<LeadAddChannelMutation, LeadAddChannelMutationVariables>(
        LEAD_ADD_CHANNEL
    );

    return (input: {channel: ChannelType | 'NO_CHANNEL'; leadId: string}) => {
        return addChannel({
            variables: {
                input: {
                    channel: input.channel === 'NO_CHANNEL' ? null : input.channel,
                    leadId: input.leadId,
                },
            },
            optimisticResponse: {
                leadAddChannel: {
                    __typename: 'LeadAddChannelPayload',
                    lead: {
                        __typename: 'Lead',
                        id: input.leadId,
                    },
                },
            },
            update: (proxy) => {
                const cacheResult: GetLeadChannelsQuery | null | undefined = proxy.readQuery({
                    query: GET_LEAD_CHANNELS,
                    variables: {id: input.leadId},
                });

                if (cacheResult && cacheResult.lead) {
                    proxy.writeQuery({
                        query: GET_LEAD_CHANNELS,
                        variables: input.leadId,
                        data: {
                            lead: {
                                ...cacheResult.lead,
                                channels: {
                                    ...cacheResult.lead.channels,
                                    edges: [
                                        ...(cacheResult.lead.channels
                                            ? cacheResult.lead.channels.edges
                                            : []),
                                        {
                                            __typename: 'LeadChannelsEdge',
                                            node: {
                                                __typename: 'Channel',
                                                value: input.channel,
                                                title: input.channel,
                                            },
                                            sources: [],
                                        },
                                    ],
                                },
                            },
                        },
                    });
                }
            },
        });
    };
}
